import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getTours } from "@/api";
import TourCard from "@/components/TourCard";
import { useLang } from "@/i18n";
import { Link } from "react-router-dom";

export default function ToursGrid({ limit }) {
  const { data = [], isLoading } = useQuery({ queryKey: ["tours"], queryFn: getTours });
  const { t } = useLang();
  const items = limit ? data.slice(0, limit) : data;

  return (
    <section data-testid="tours-grid-section" className="max-w-[1440px] mx-auto px-6 md:px-12 py-24 md:py-32">
      <div className="grid md:grid-cols-12 gap-8 mb-14 md:mb-20 items-end">
        <div className="md:col-span-7">
          <p className="eyebrow mb-4">{t("tours.kicker")}</p>
          <h2 className="font-serif-hc font-light text-4xl md:text-5xl lg:text-[56px] leading-[1.05] text-[#F5F2EA]">
            {t("tours.title")}
          </h2>
          <p className="mt-5 text-[#A3A095] max-w-xl leading-relaxed">{t("tours.sub")}</p>
        </div>
        {limit && (
          <div className="md:col-span-4 md:col-start-9 md:text-right">
            <Link to="/tours" data-testid="tours-see-all" className="hc-btn-secondary">
              {t("tours.all")}
            </Link>
          </div>
        )}
      </div>

      {isLoading ? (
        <div className="grid md:grid-cols-3 gap-6">
          {[0, 1, 2].map((i) => (
            <div key={i} className="bg-[#0C1310] border border-[#1E2B25] aspect-[4/5] animate-pulse" />
          ))}
        </div>
      ) : (
        <div className="flex md:grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 overflow-x-auto md:overflow-visible snap-x snap-mandatory scrollbar-hide -mx-6 px-6 md:mx-0 md:px-0 pb-2 md:pb-0">
          {items.map((tour, i) => (
            <div key={tour.id} className="min-w-[82%] sm:min-w-[55%] md:min-w-0 snap-start">
              <TourCard tour={tour} index={i} />
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
